import React from 'react';
import { Form, Input, Button } from 'antd';

interface AssetCategoryFormProps {
  form: any;
  initialValues?: any;
  onFinish: (values: any) => void;
  loading?: boolean;
  submitText?: string;
  hideFields?: string[];
}

const AssetCategoryForm: React.FC<AssetCategoryFormProps> = ({
  form,
  initialValues = {},
  onFinish,
  loading = false,
  submitText = 'Lưu',
  hideFields = [],
}) => {
  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={initialValues}
      onFinish={onFinish}
    >
      {!hideFields.includes('name') && (
        <Form.Item
          name="name"
          label="Tên danh mục"
          rules={[{ required: true, message: 'Nhập tên danh mục!' }]}
        >
          <Input placeholder="Tên danh mục" size="large" />
        </Form.Item>
      )}
      {!hideFields.includes('description') && (
        <Form.Item name="description" label="Mô tả">
          <Input placeholder="Mô tả" size="large" />
        </Form.Item>
      )}
      <Form.Item style={{ marginBottom: 0 }}>
        <Button type="primary" htmlType="submit" size="large" loading={loading} style={{ width: '100%' }}>
          {submitText}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default AssetCategoryForm; 